'use client';

import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

interface RootStyleProps {
  rounded: boolean;
}

export const StyledElements = styled( Box, {
  shouldForwardProp: (prop) => prop !== 'rounded',
} )<RootStyleProps>(({ rounded }) => ({
  display: 'flex',
  listStyle: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  '& li': {
    width: 18,
    height: 18,
    opacity: 0.32,
    cursor: 'pointer',
  },
  '& li.slick-active': {
    opacity: 1,
    ...(rounded && {
      '& .dotActive': {
        width: 16,
        borderRadius: 6,
      },
    }),
  },
}));

export const DotWrapStyle = styled( 'div' )(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const DotStyle = styled( 'span' )(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  transition: theme.transitions.create( 'width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.short,
  } ),
}));
